import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// types
import { EquipmentPayloadType } from '@/api/types/request/EquipmentPayloadType'
import { EquipmentDeleteType, EquipmentType } from '@/api/types/response/EquipmentType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}/{siteId}/paperwork/equipment
 */
export default class EquipmentApi extends AbstractApi {
  add(payload: EquipmentPayloadType): Promise<EquipmentType> {
    return httpClient.post(this.apiEnd, payload)
  }

  remove(id: number): Promise<EquipmentDeleteType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }
}
